import React from 'react';
import { Text } from '@/ui/typography';

export const TextList = ({ question }) => {
  return (
    <>
      {question.question && (
        <>
          <Text $fontSize={14}>{question.question}</Text>
          {/*<Label*/}
          {/*  label={question.question}*/}
          {/*  required={required}*/}
          {/*  tooltip={question.tooltip ? getLocalizedText(question, 'tooltip', i18n) : null}*/}
          {/*  // layout={*/}
          {/*  //   question?.availableAnswers && question?.availableAnswers.length > 0*/}
          {/*  //     ? 'vertical'*/}
          {/*  //     : 'horizontal'*/}
          {/*  // }*/}
          {/*  //colon={false}*/}
          {/*>*/}
          {question?.availableAnswers && question?.availableAnswers.length > 0 && (
            <ul>
              {question?.availableAnswers?.map((answer, key) => {
                return (
                  <li key={key}>
                    <Text $fontSize={14}>{answer.answer}</Text>
                  </li>
                );
              })}
            </ul>
          )}
          {/*</Label>*/}
        </>
      )}
    </>
  );
};
